import { render, staticRenderFns } from "./TabelaProdutos.vue?vue&type=template&id=0aa21ddc&scoped=true"
import script from "./TabelaProdutos.vue?vue&type=script&lang=js"
export * from "./TabelaProdutos.vue?vue&type=script&lang=js"
import style0 from "./TabelaProdutos.vue?vue&type=style&index=0&id=0aa21ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa21ddc",
  null
  
)

export default component.exports